export function compactGqlQuery(query: string): string {
    return query.replace(/\s+/g, ' ').trim()
}
